<template>
<span>
<div class="pt-3" v-if="product.category"><a :href="`/cat/${product.category.id}/${createSlug(product.category.name)}`">{{product.category.name}}</a> <span class="px-2">/</span> <a :href="`/category/${product.sub_category.id}/${createSlug(product.sub_category.name)}`">{{product.sub_category.name}}</a></div>

<div v-if="product.url" class="text-center pt-3">
  <banner1></banner1>
</div>

<div class="card border mt-3" 
v-if="user && (user.id == product.seller_id || user.account == 'Admin')" style="background:rgb(26,32,44);border:none !important;border-radius:5px !important;">
  <div class="card-body py-2">
    <div class="row">
      <div class="col">
        <i class="fas fa-check-circle mr-1" style="color:#fff;" v-if="product.status == 'Approved'"></i>
        <i class="fas fa-times-circle mr-1" style="color:#fff;" v-else></i>
        <span :class="setClass(product.status)" style="color:#fff;">{{product.status}}</span>

        <i v-if="product.status == 'Approved'" class="fas fa-eye ml-2 mr-1" style="color:#fff;" :title="`${product.views} ${product.views === 1 ? 'view' : 'views'}`"></i>
        <span v-if="product.status == 'Approved'" style="color:#fff;" :title="`${product.views} ${product.views === 1 ? 'view' : 'views'}`">{{product.views}}</span>

        <span v-if="product.status == 'Rejected' && product.reason" style="color:#fff;"> &bull; {{product.reason}}</span>
        <span v-if="product.status != 'Approved'" style="color:#fff;" class="hide-mobile"> &bull; Only you can see this product</span>
        </div>
      <div class="col text-right">
        <a :href="`/products/${product.id}/edit`" style="color:#fff;">Edit</a>
        <a v-if="user && user.account == 'Admin'" href="#/" @click="showModalReviewProduct(product)" title="Review" style="color:#fff;" class="ml-3">Review</a>
        </div>
    </div>
  </div>
</div>
<review-product v-if="product && user && user.account == 'Admin'" :product="product" @product-reviewed="getProduct()" ref="ReviewProduct"></review-product>
</span>
</template>

<script>
export default {
props : ['user', 'product'],

  methods: {

    getProduct() {
        this.$emit('product-reviewed');
    },

    showModalReviewProduct(product) {
      this.selectedProduct = product;
      this.$refs.ReviewProduct.clearContent();
      this.$bvModal.show('bv-modal-review-product-'+this.page);
    },

  },
};
</script>